import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ToastService } from '../../shared/services/toast.service';
import { PUBLIC_AUTH_PATHS } from './auth.interceptor';

export const errorToastInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(ToastService);

  return next(req).pipe(
    catchError((error: unknown) => {
      // Auth endpoints render their own precise error copy (e.g. the login form's
      // account-not-found / wrong-password messages) or are handled silently
      // (init() /auth/me). A generic "Http failure response …" toast on top would
      // duplicate — and RFC 7807 bodies carry `detail`, not `message`, so the
      // fallback text would be misleading. Skip toasting for those URLs only.
      if (
        error instanceof HttpErrorResponse &&
        !PUBLIC_AUTH_PATHS.some((p) => req.url.includes(p))
      ) {
        const message =
          (error.error as { message?: string })?.message ??
          error.message ??
          'An unexpected error occurred';
        toast.error(message);
      }
      return throwError(() => error);
    }),
  );
};
